export const getGridColumns = (qrPerPage, machineCount) => {
  const columns = [];
  const count = Math.min(qrPerPage, machineCount); // Ensure we do not exceed actual machine count
  const colSize = count <= 2 ? 6 : count <= 4 ? 6 : count <= 6 ? 4 : 4;
  
  for (let i = 0; i < count; i++) {
    columns.push(colSize);
  }
  return columns;
};


// Calculate QR code size based on QR codes per page
export const getQRSize = (qrPerPage) => {
  switch (qrPerPage) {
    case 1:
      return 300;
    case 2:
      return 250;
    case 4:
      return 230;
    case 6:
      return 180;
    case 8:
      return 170;
    case 9:
      return 160;
    default:
      return 150;
  }
};
